<template>
  <!-- 编辑或手动添加订单 -->
  <div class="">
    <vs-popup 
      fullscreen
      :title="modalTitle"
      :active.sync="popupActive">
     

    </vs-popup>
</div>
</template>

<script>
  export default {
    props: {
      popupActive: {
        type: Boolean,
        default: false
      },
      detail: {
        type: Object,
        default: null
      }
    },
    computed: {
      modalTitle() {
        return this.detail.orderStatusDesc 
      }
    },
    data() {
      return {
        statusName: ''
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/modules/commodity-sys/commodity.scss';
  .title-wrap{
    height: 146px;
    color: #5E5873;
    font-size: 14px;
    .yellow-text{
      color: #FF8D23;
    }
    .title{
      font-size: 18px;  
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
    }
  }
  
</style>